<script lang="ts">
  import type { HTMLAnchorAttributes } from "svelte/elements";

  let className: string | undefined | null = undefined;
  export { className as class };
  export let href: HTMLAnchorAttributes["href"];

  /**
   * @type {boolean}
   * @default false
   * @description Whether the link is internal or external. If the link is external, it will open in a new tab and have `noopener noreferrer` added to the `rel` attribute. If the link is internal, it will open in the same tab and have no `rel` attribute.
   * @example
   * ```html
   * This would open as an external link:
   * <Link href="https://app.provi.com">Provi</Link>
   * ```
   * These are examples of internal links:
   * ```html
   * <Link href="/product_listing">All Products</Link>
   * ```
   * ```html
   * <Link href="#contact">Contact</Link>
   * ```
   */

  $: internal = href.startsWith("/") || href.startsWith("#");
  $: rel = !internal ? "noopener noreferrer" : undefined;
  $: target = !internal ? "_blank" : undefined;

</script>

<a on:click {href} {target} {rel} class={className} {...$$restProps}>
  <slot />
</a>
